// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const sl: KnowledgePagesCopy = {
  knowledgePage: 'Stran znanja',
  knowledgePages: 'Strani znanja',
  featureOffTitle: 'Strani znanja v tem delovnem prostoru niso omogočene.',
  featureOffBody: 'Kontekst podjetja in viri so še vedno v razdelku Znanje.',
  loadingPage: 'Nalaganje strani…',
  loadingSuggestion: 'Nalaganje predloga…',
  cancel: 'Prekliči',
  tryAgain: 'Poskusi znova',
  everyoneIn: 'Vsi v podjetju {company}',
  yourCompany: 'vašem podjetju',
  revision: 'Revizija {n}',
  openRevision: 'Odpri revizijo {n}',
  pageCount: 'one:stran|two:strani|few:strani|other:strani',
  topicCount: 'one:tema|two:temi|few:teme|other:tem',
  sectionCount: 'one:razdelek|two:razdelka|few:razdelki|other:razdelkov',
  lineCount: 'one:vrstica|two:vrstici|few:vrstice|other:vrstic',
  documentCount: 'one:dokument|two:dokumenta|few:dokumenti|other:dokumentov',
  changeCount: 'one:sprememba|two:spremembi|few:spremembe|other:sprememb',
  newPageCount: 'one:nova stran|two:novi strani|few:nove strani|other:novih strani',
  changedPageCount:
    'one:spremenjena stran|two:spremenjeni strani|few:spremenjene strani|other:spremenjenih strani',
  otherSectionCount:
    'one:drug razdelek|two:druga razdelka|few:drugi razdelki|other:drugih razdelkov',
  characterCount: 'one:znak|two:znaka|few:znaki|other:znakov',
  diffStats: 'Spremenjeno: {sections} · dodano: {added} · odstranjeno: {removed}',
  diffMatchesBase: 'Predlagano besedilo se ujema z izhodiščno revizijo.',
  diffIntroduction: 'Uvod',
  diffOtherUnchanged: 'Nespremenjeno: {sections}.',
  timeJustNow: 'pravkar',
  originImportedFrom: 'Uvoženo iz {path}',
  originImportedFromCommit: 'Uvoženo iz {path} @ {commit}',
  authorityApprovedInPoneva: 'Odobreno v aplikaciji Poneva',
  authorityImported: 'Uvoženo',
  authorityInRepository: '{canonicality} v repozitoriju',
  authorityVerified: 'preverjeno {date}',
  authorRepositoryImport: 'Uvoz iz repozitorija',
  authorSuggestedInChat: 'Predlagano v klepetu',
  authorSuggestedInChatWith: 'Predlagano v klepetu z uporabnikom {name}',
  authorSuggestedBy: 'Predlaga: {name}',
  authorSuggestedByApp: 'Predlaga povezana aplikacija',
  authorSuggestedByColleague: 'Predlaga sodelavec',
  authorSuggestedByYou: 'Predlagali ste vi',
  authorSuggestedOnBehalf: 'Predlaga {app} v imenu uporabnika {name}',
  authorSuggestedByAppOnBehalf: 'Predlaga povezana aplikacija v imenu uporabnika {name}',
  authorSuggestedAndApproved: 'Predlagal in odobril: {name}',
  approverApprovedBy: 'odobril: {name}',
  approverAppliedBy: 'uveljavil: {name}',
  kindCreatePage: 'Nova stran',
  kindUpdatePage: 'Predlagana posodobitev',
  kindArchivePage: 'Arhiviranje',
  statusConflict: 'Spor · stran se je spremenila',
  statusPending: 'Čaka na pregled',
  statusApproved: 'Odobreno',
  statusRejected: 'Opuščeno',
  statusWithdrawn: 'Umaknjeno',
  statusSuperseded: 'Nadomeščeno',
  errRevisionConflict: 'Ta stran se je spremenila, medtem ko ste jo pregledovali.',
  errProposalChanged:
    'Ta predlog se je spremenil, medtem ko ste ga pregledovali. Pred odločitvijo preglejte najnovejšo različico.',
  errPublishRequired: 'Samo uredniki podjetja lahko odobrijo spremembe znanja ali uvozijo strani.',
  errProposalLimit:
    'Vaše podjetje ima že 200 predlogov, ki čakajo na pregled. Preden predlagate nove, nekatere preglejte.',
  errAuthorLimit:
    'Na pregled čaka že 50 vaših predlogov. Preden predlagate nove, počakajte na odločitev o nekaterih ali jih nekaj umaknite.',
  errImportProposalLimit:
    'Ta uvoz bi dodal več spremenjenih strani za pregled, kot jih sprejme čakalna vrsta za pregled vašega podjetja (največ 200). Odločite se o nekaterih predlogih v zavihku V pregled, nato uvoz znova uveljavite.',
  errImportChanged:
    'To ni uvoz, ki ste ga pregledali. Znova ga odprite in preglejte, preden ga uveljavite.',
  errImportItemNotFound: 'Ta dokument ni več del uvoza.',
  errIdempotencyConflict:
    'Ta predlog je bil že poslan z drugačno vsebino. Znova naložite stran in poskusite znova.',
  errImportHashMismatch:
    'Datoteka v tem posnetku se ne ujema z zabeleženo kontrolno vsoto. Ustvarite nov posnetek in poskusite znova.',
  errImportAlreadyApplied: 'Ta uvoz je že uveljavljen.',
  errImportDiscarded: 'Ta uvoz je bil zavržen. Znova izberite datoteko posnetka.',
  errImportDuplicateItem: 'Ta posnetek dvakrat navaja isti dokument. Znova ustvarite posnetek.',
  errInvalidImport:
    'Poneva tega posnetka ni mogla sprejeti. Ustvarite novega s skriptom za posnetke in poskusite znova.',
  errInvalidInput: 'Poneva teh podatkov ni mogla sprejeti. Preverite polja in poskusite znova.',
  errImportLimit:
    'Preveč uvozov je pripravljenih, a ne uveljavljenih. Preden pripravite novega, nekatere uveljavite ali zavrzite.',
  errPageTooLarge: 'Stran je večja od 256 KB. Razdelite jo na manjše strani.',
  errTooManySections: 'Stran ima več kot 2.000 naslovov. Razdelite jo na manjše strani.',
  errPageLimit: 'Vaše podjetje je doseglo omejitev 2.000 strani znanja.',
  errCollectionLimit: 'Vaše podjetje je doseglo omejitev 100 tem.',
  errProposalNotPending: 'O tem predlogu je že bilo odločeno. Prikazano stanje je trenutno.',
  errRequesterRemoved:
    'Oseba, ki je to predlagala, ni več v tem podjetju, zato predloga ni mogoče odobriti.',
  errRevisionAlreadyCurrent: 'Ta revizija je že trenutna.',
  errPageArchived:
    'Ta stran je bila arhivirana, medtem ko ste jo pregledovali. Pred odločitvijo znova preglejte predlog.',
  errAlreadyArchived: 'Ta stran je že arhivirana.',
  errProposalForbidden: 'Predlog lahko umakne samo oseba, ki ga je predlagala.',
  errUnavailable: 'Strani znanja trenutno niso na voljo.',
  errTimeout: 'Poneva je predolgo odgovarjala.',
  errItemTooLarge: 'Datoteka {path} je večja od 256 KB. Razdelite jo na manjše strani.',
  errItemTooManySections:
    'Datoteka {path} ima več kot 2.000 naslovov. Razdelite jo na manjše strani.',
  errItemHashMismatch:
    'Datoteka {path} se ne ujema z zabeleženo kontrolno vsoto. Ustvarite nov posnetek in poskusite znova.',
  errNoLongerAvailable: 'Ta element vam ni več na voljo.',
  errTooLargeToSend: 'Ta datoteka je prevelika za pošiljanje.',
  cardChecking: 'Preverjanje stanja…',
  cardNotAvailable: 'Ni na voljo',
  cardStatusUnavailable: 'Stanje ni na voljo',
  cardUnshowable: 'Te predlagane posodobitve znanja ni bilo mogoče prikazati.',
  cardEyebrow: 'Predlagana posodobitev znanja',
  cardLabel: 'Predlagana posodobitev znanja · {title}',
  cardMissing: 'Ta predlog vam ni več na voljo.',
  cardUnknown:
    'Stanja tega predloga nismo mogli preveriti. Odprite pregled, da vidite njegovo stanje.',
  cardCheckAgain: 'Preveri znova',
  cardReview: 'Preglej posodobitev',
  statusLineApproved: 'Odobreno razumevanje',
  readyCount:
    'one:pripravljen za iskanje|two:pripravljena za iskanje|few:pripravljeni za iskanje|other:pripravljenih za iskanje',
  preparingCount: 'one:v pripravi|two:v pripravi|few:v pripravi|other:v pripravi',
  attentionCount:
    'one:zahteva pozornost|two:zahtevata pozornost|few:zahtevajo pozornost|other:zahteva pozornost',
  topicsExplore: 'Raziščite temo',
  topicsAllPages: 'Vse strani',
  topicsOpenPages: 'Odpri Strani',
  topicsEmpty:
    'Odobrenih strani še ni. Strani vsebujejo obsežnejše razumevanje podjetja s celotno zgodovino revizij.',
  reviewsTitle: 'Predlagane posodobitve strani',
  reviewsTitleMine: 'Vaše predlagane posodobitve strani',
  reviewsIntro:
    'Vsak predlog je celotna kandidatna revizija z razlogom in dokazi. Nič se ne spremeni, dokler ne odobrite natanko te revizije.',
  reviewsIntroMine:
    'Vaši predlogi čakajo tukaj, dokler jih ne pregleda urednik podjetja. Do takrat strani ostanejo nespremenjene.',
  loadPagesFailed: 'Strani znanja nismo mogli naložiti.',
  loadProposalsFailed: 'Predlaganih posodobitev strani nismo mogli naložiti.',
  loadMoreFailed: 'Več strani nismo mogli naložiti.',
  otherPages: 'Druge strani',
  loadTopicFailed: 'Te teme nismo mogli naložiti.',
  revisionShort: 'r{n}',
  updatedOn: 'Posodobljeno {date}',
  emptyTitle: 'Strani znanja še ni.',
  emptyBody:
    'Strani vsebujejo odobreno, obsežnejše razumevanje vašega podjetja — usmeritev, odločitve in načine dela — in ohranijo vsako revizijo. Uvozite jih iz posnetka repozitorija ali začnite stran v klepetu; urednik podjetja odobri vsako stran, preden šteje kot znanje podjetja.',
  importFromSnapshot: 'Uvozi iz posnetka repozitorija',
  startInChat: 'Začni stran v klepetu',
  startInChatPrompt:
    'Pomagaj mi začeti stran znanja za naše podjetje. Vprašaj me, kaj naj zajema, in si ne izmišljuj vsebine. Ostane predlog, dokler je ne odobri urednik podjetja.',
  loadingPages: 'Nalaganje strani znanja…',
  filterLabel: 'Filtriraj strani po naslovu',
  filterPlaceholder: 'Filtriraj strani',
  importButton: 'Uvozi',
  showingTopic: 'Prikazano: {topic}',
  showAllTopics: 'Prikaži vse teme',
  loadingTopic: 'Nalaganje teme…',
  noMatch: 'Nobena stran se ne ujema z »{filter}«.',
  topicNoPages: 'V tej temi še ni odobrenih strani.',
  loading: 'Nalaganje…',
  loadMore: 'Naloži več strani',
  metaApproved: 'odobreno {date}',
  metaRepositoryAuthoritative: 'verodostojen vir ostaja repozitorij',
  loadPageFailed: 'Te strani nismo mogli naložiti.',
  loadHistoryFailed: 'Zgodovine revizij nismo mogli naložiti.',
  outlineLabel: 'Razdelki strani',
  outlineToggle: 'Na tej strani',
  loadingHistory: 'Nalaganje zgodovine revizij…',
  historyLabel: 'Zgodovina revizij',
  historyIntro:
    'Vsaka odobrena revizija se ohrani. Obnovitev starejše ustvari predlog za pregled; poznejših revizij nikoli ne izbriše.',
  historyCurrent: 'Trenutna',
  historyViewing: 'Prikazana',
  historyView: 'Prikaži',
  historyViewAria: 'Prikaži revizijo {n}',
  restoreAria: 'Obnovi kot predlog: revizija {n}',
  restoreCreating: 'Ustvarjanje predloga…',
  restore: 'Obnovi kot predlog',
  restoreUnconfirmed:
    'Nismo mogli potrditi, da je bil predlog ustvarjen. Preden poskusite znova, preverite zavihek V pregled.',
  editTooLarge: 'Ta stran je večja od 256 KB. Preden jo predlagate, jo razdelite na manjše strani.',
  editConflict:
    'Ta stran se je spremenila, medtem ko ste jo urejali. Kopirajte svoje besedilo, odprite najnovejšo revizijo in spremembo predlagajte znova.',
  editUnconfirmed:
    'Nismo mogli potrditi, da je bil vaš predlog poslan. Preden ga pošljete znova, preverite zavihek V pregled.',
  editHeading: 'Predlagaj spremembo',
  editIntro:
    'Urejate revizijo {n}. Urednik podjetja pregleda natančno spremembo, preden postane revizija {next}; do takrat stran ostane nespremenjena.',
  editOutdated:
    'Medtem ko ste urejali, je bila odobrena novejša revizija. Kopirajte svoje besedilo in začnite znova iz najnovejše revizije, da se nič od njenih sprememb ne izgubi.',
  editContentLabel: 'Vsebina strani (Markdown)',
  editReasonLabel: 'Zakaj ta sprememba?',
  editReasonPlaceholder: 'Kaj se je spremenilo in od kod to izhaja.',
  editSending: 'Pošiljanje…',
  editSend: 'Pošlji v pregled',
  editDiscardConfirm:
    'Želite zavreči to spremembo? Nič od tega, kar ste spremenili, ni bilo poslano.',
  editNoChanges: 'Sprememb še ni.',
  editNeedsContent: 'Stran potrebuje nekaj vsebine.',
  exportFailed: 'Te strani nismo mogli izvoziti. Poskusite znova.',
  askPagePrompt: 'Vprašanje o strani znanja »{title}« (revizija {n}, {link}):',
  askPageSectionPrompt: 'Vprašanje o strani znanja »{title}« § {section} (revizija {n}, {link}):',
  pageMissingTitle: 'Ta stran ni na voljo.',
  pageMissingBody: 'Morda je bila arhivirana ali pa nimate več dostopa do znanja tega podjetja.',
  pageArchived: 'Arhivirano',
  viewingRevisionCurrent: 'Ogledujete si revizijo {n}; trenutna revizija je {current}.',
  viewingRevisionOld: 'Ogledujete si revizijo {n}. To ni trenutna revizija.',
  openCurrent: 'Odpri trenutno',
  archivedBanner:
    'Ta stran je arhivirana. Ne vpliva več na odgovore; njena zgodovina je ohranjena.',
  pageViewsLabel: 'Pogledi strani',
  tabRead: 'Branje',
  tabHistory: 'Zgodovina',
  unknownSection: 'Povezani razdelek ni del te revizije. Prikazana je celotna stran.',
  askAboutPage: 'Vprašaj o tej strani',
  exporting: 'Izvažanje…',
  exportMarkdown: 'Izvozi Markdown',
  loadSuggestionFailed: 'Tega predloga nismo mogli naložiti.',
  evidenceSource: 'Vir',
  evidenceFact: 'Kontekst podjetja',
  evidenceResult: 'Shranjeno delo',
  evidenceUrl: 'Spletna stran',
  evidenceDecision: 'Odločitev',
  evidenceReference: 'Referenca',
  evidenceOpenPage: 'Odpri stran znanja',
  evidenceOpenSource: 'Odpri vir',
  evidenceOpenFact: 'Odpri kontekst podjetja',
  evidenceOpenResult: 'Odpri shranjeno delo',
  evidenceOpenUrl: 'Odpri spletno stran',
  evidenceOpenDecision: 'Odpri odločitev',
  evidenceOpenReference: 'Odpri referenco',
  evidenceDecisionNote: 'Zabeležena odločitev. V aplikaciji Poneva ni ničesar za odpiranje.',
  evidenceFactGone: 'Ta kontekst podjetja ni več shranjen.',
  evidencePageNoRevision: 'Ta stran nima odobrene revizije, ki bi jo lahko odprli.',
  evidencePrivateExcerpt: 'Zasebni dokaz — deljen je bil samo zgornji izsek.',
  evidencePrivate: 'Zasebni dokaz — njegova vsebina ni bila deljena z vami.',
  evidenceHeading: 'Dokazi',
  evidenceNone: 'Priložen ni bil noben dokaz. Zgornji razlog presodite samostojno.',
  changeAdded: 'Dodano',
  changeRemoved: 'Odstranjeno',
  changeChanged: 'Spremenjeno',
  changeUnchanged: 'Nespremenjeno',
  moreLineCount: 'one:vrstica|two:vrstici|few:vrstice|other:vrstic',
  moreUnchangedLineCount:
    'one:nespremenjena vrstica|two:nespremenjeni vrstici|few:nespremenjene vrstice|other:nespremenjenih vrstic',
  unchangedLineCount:
    'one:nespremenjena vrstica|two:nespremenjeni vrstici|few:nespremenjene vrstice|other:nespremenjenih vrstic',
  skipAdded: 'Še {lines} — prikazano v celotni reviziji',
  skipRemoved: 'Odstranjeno še: {lines}',
  cutUnchanged: 'Ni prikazano: {lines}',
  cutChanged: 'Ni prikazano: {lines}, {changes}. Preverite jih v celotni reviziji.',
  cutAddedRemoved: 'dodano: {added}, odstranjeno: {removed}',
  cutAdded: 'dodano: {added}',
  cutRemoved: 'odstranjeno: {removed}',
  lineAddedSr: 'Dodano:',
  lineRemovedSr: 'Odstranjeno:',
  noLinesAdded: 'Nov razdelek. Njegovo besedilo je v celotni reviziji spodaj.',
  noLinesRemoved: 'Ta razdelek bi bil odstranjen s strani.',
  noLinesChanged: 'Ta razdelek se spremeni. Njegovo besedilo je v celotni reviziji spodaj.',
  diffHeading: 'Spremembe',
  outcomeArchived: 'Arhivirano.',
  outcomeArchivedBody:
    '{title} ne vpliva več na odgovore in ni več na seznamu strani. Njene revizije, ta predlog in odločitev ostanejo v zgodovini strani.',
  openArchivedPage: 'Odpri arhivirano stran',
  outcomeApproved: 'Odobreno.',
  outcomeApprovedRevision: 'Revizija {n} je zdaj odobrena različica strani {title}.',
  outcomeApprovedPlain: 'Ta predlog je bil odobren.',
  outcomeRestored: 'Stran je spet na seznamu strani in znova vpliva na odgovore.',
  outcomeKept: 'Predlog, odločitev in vse prejšnje revizije ostanejo v zgodovini strani.',
  openPage: 'Odpri stran',
  outcomeDismissed: 'Opuščeno.',
  outcomeWithdrawn: 'Umaknjeno.',
  outcomeSuperseded: 'Nadomeščeno.',
  outcomeSupersededBody:
    'Novejša revizija, predlog ali uvoz iz repozitorija je ta predlog nadomestil. Sam ni ničesar spremenil.',
  outcomeUnchanged: 'Stran ostane nespremenjena.',
  approveNewPage: 'Odobri novo stran',
  approveArchive: 'Odobri arhiviranje',
  approveRestoreRevision: 'Obnovi in odobri revizijo {n}',
  approveRevision: 'Odobri revizijo {n}',
  approveArchiveNote: 'Z odobritvijo se ta stran arhivira za vse v {company}.',
  approvePublishNote: 'Z odobritvijo se ta revizija objavi za vse v {company}.',
  approvePublishEvidenceNote:
    'Z odobritvijo se ta revizija in zgoraj prikazani izseki dokazov objavijo za vse v {company}.',
  archivedTitle: 'Ta stran je arhivirana.',
  alreadyArchivedBody:
    'Odobritev ne bi ničesar spremenila, zato je ta predlog mogoče samo opustiti.',
  archivedRestoreBody:
    'Z odobritvijo se stran obnovi: s to revizijo se vrne na seznam strani, v iskanje in v odgovore.',
  staleRevisionAction: 'Primerjaj z najnovejšo različico',
  staleProposalTitle: 'Ta predlog se je spremenil, medtem ko ste ga pregledovali.',
  staleProposalAction: 'Preglej najnovejšo različico',
  staleArchivedTitle:
    'Ta stran je bila arhivirana, medtem ko ste jo pregledovali. Z odobritvijo tega predloga bi se vrnila.',
  staleArchivedAction: 'Preglej znova',
  suggestionMissingTitle: 'Ta predlog ni na voljo.',
  suggestionMissingBody:
    'Morda je bil umaknjen ali pa pripada nekomu drugemu in ni bil poslan v pregled podjetju.',
  decideUnconfirmed:
    'Vaše odločitve nismo mogli potrditi. Prikazano stanje je najnovejše iz aplikacije Poneva; preverite ga, preden poskusite znova.',
  decideFailed: 'Vaše odločitve nismo mogli shraniti.',
  discussPrompt: 'Pomagaj mi izpopolniti predlagano posodobitev znanja za »{title}« ({link}).',
  conflictBody:
    'Ta predlog je bil napisan na podlagi revizije {base}; trenutna revizija je {current}. Z odobritvijo bi se ta sprememba prepisala, zato ga v tej obliki ni mogoče odobriti.',
  conflictBodyPlain:
    'Ta predlog je bil napisan na podlagi starejše revizije, zato ga v tej obliki ni mogoče odobriti.',
  openLatest: 'Odpri najnovejšo različico',
  reworkInChat: 'Predelaj v klepetu',
  factReason: 'Razlog',
  factNoReason: 'Razlog ni bil naveden.',
  factAudience: 'Občinstvo',
  factRevision: 'Revizija',
  revisionNew: 'Nova stran, revizija 1',
  revisionArchiveAfter: 'Arhiviranje po reviziji {n}',
  revisionWrittenAgainst: 'Napisano na podlagi revizije {base}; trenutna revizija je {current}',
  revisionCurrentToProposed: 'Trenutna revizija {base} → predlagana revizija {next}',
  revisionProposed: 'Predlagana revizija {next}',
  proposedPage: 'Predlagana stran',
  archivingHeading: 'Kaj naredi arhiviranje',
  archivingBody:
    'Stran ne vpliva več na odgovore in izgine s seznama strani. Njene revizije in ta odločitev se ohranijo.',
  noComparison: 'Primerjava razdelkov za ta predlog ni na voljo.',
  showComplete: 'Prikaži celotno revizijo',
  approving: 'Odobravanje…',
  dismissing: 'Opuščanje…',
  dismiss: 'Opusti',
  withdrawing: 'Umikanje…',
  withdraw: 'Umakni',
  editInChat: 'Uredi v klepetu',
  waitingForPublisher: 'Čaka, da ga pregleda urednik podjetja.',
  snapshotTooLarge: 'Ta posnetek je večji od 8 MB. Ustvarite ga z manj dokumenti.',
  snapshotNotSnapshot:
    'Ta datoteka ni posnetek znanja. Izberite datoteko JSON, ki jo je ustvaril skript za posnetke.',
  snapshotEmpty: 'Ta posnetek ne vsebuje dokumentov.',
  readDocumentFailed: 'Tega dokumenta nismo mogli prebrati. Poskusite znova.',
  readingDocument: 'Branje dokumenta…',
  hideText: 'Skrij besedilo',
  readText: 'Preberi besedilo',
  textOf: 'Besedilo dokumenta {title}',
  gitSnapshot: 'Posnetek Git {commit}',
  repositorySnapshot: 'Posnetek repozitorija',
  importNewHeading: '{pages} · odobreno ob uveljavitvi',
  importNewNote:
    'Vsaka se objavi kot odobrena stran za vse v podjetju {company}, brez nadaljnjega pregleda. Preden uvoz uveljavite, vsako preberite.',
  importChangedHeading: '{pages} · poslano v pregled',
  importChangedNote:
    'Vsaka postane predlagana posodobitev. Njena stran se spremeni šele, ko jo urednik odobri v zavihku V pregled, ki prikaže, kaj se je spremenilo.',
  unchangedDocumentCount:
    'one:nespremenjen dokument|two:nespremenjena dokumenta|few:nespremenjeni dokumenti|other:nespremenjenih dokumentov',
  unchangedNote: 'Ti se že ujemajo s svojimi odobrenimi stranmi. Zanje se nič ne zapiše.',
  stagedHeading: 'Pripravljeno, a ne uveljavljeno',
  excludedSummary: 'Izpuščeno iz tega posnetka: {documents}',
  countsLine: '{newPages} · za pregled: {changedPages} · nespremenjeno: {unchanged}',
  importAlreadyDiscarded: 'Ta uvoz je že bil zavržen.',
  confirmLabel: 'Potrdi uvoz',
  unchangedKeepCount:
    'one:nespremenjen dokument obdrži svojo stran|two:nespremenjena dokumenta obdržita svoji strani|few:nespremenjeni dokumenti obdržijo svoje strani|other:nespremenjenih dokumentov obdrži svoje strani',
  confirmBody:
    'Želite uveljaviti ta uvoz za vse v podjetju {company}? Kot revizija 1 bo odobreno: {newPages}; na pregled bo čakalo: {changedPages}; {unchanged}. Prejšnji predlogi uvoza za te strani bodo umaknjeni.',
  applying: 'Uveljavljanje…',
  applyImport: 'Uveljavi uvoz',
  chooseAnother: 'Izberi drugo datoteko',
  allCurrent: 'Vse v tem posnetku je že posodobljeno.',
  importApplied: 'Uvoz je uveljavljen.',
  appliedSummary: 'Ustvarjeno: {pages} · čaka na pregled: {changes} · nespremenjeno: {unchanged}.',
  appliedIndexing:
    'Nove strani bodo v klepetu iskalne, ko se indeksiranje konča. Napredek je prikazan pri pripravi virov.',
  openPages: 'Odpri strani',
  reviewChanges: 'Preglej spremembe ({changes})',
  checkIndexing: 'Preveri napredek indeksiranja',
  sendSnapshotFailed: 'Tega posnetka nismo mogli poslati. Poskusite znova.',
  openStagedFailed: 'Tega pripravljenega uvoza nismo mogli odpreti.',
  applyUnconfirmed:
    'Nismo mogli potrditi, ali je bil uvoz uveljavljen. Preden poskusite znova, preverite zavihek Strani.',
  applyFailed: 'Tega uvoza nismo mogli uveljaviti.',
  importHeading: 'Uvozi strani iz repozitorija',
  backToPages: 'Nazaj na strani',
  importLead:
    'Ustvarite posnetek z ukazom {command} in nato izberite datoteko. Preden se karkoli shrani, boste videli vsak dokument in kaj bi spremenil.',
  snapshotFileLabel: 'Datoteka posnetka znanja',
  readingSnapshot: 'Branje posnetka…',
  openingStaged: 'Odpiranje pripravljenega uvoza…',
  chooseSnapshot: 'Izberi datoteko posnetka',
  factOrigin: 'Izvor',
  factContents: 'Vsebina',
  importOnlyListed: 'Uvozijo se samo tukaj navedeni dokumenti.',
  importRepositoryAuthoritative:
    'Verodostojen vir ostaja repozitorij; spremenjeni dokumenti postanejo predlogi za pregled.',
  overviewReviewChanges: 'Preglej spremembe',
  overviewConnectAgents: 'Poveži zunanje agente',
  overviewEyebrow: 'Skupno razumevanje',
  overviewTitle: '{company} v kontekstu.',
  overviewLeadFallback:
    'Znanje vašega podjetja se začne s kontekstom, ki ga delite. Skupaj gradite razumevanje svojega poslovanja.',
  overviewBody:
    'Kontekst podjetja in izvorno gradivo dajo aplikaciji Poneva izhodišče — ne pa vsega, kar je mogoče vedeti o podjetju {company}. To razumevanje gradite naprej, ko se vaše poslovanje razvija.',
  overviewAskPrompt: 'Kaj veš o našem podjetju in kaj bi bilo koristno dodati?',
  overviewAsk: 'Vprašaj o podjetju {company}',
  overviewAddSources: 'Dodaj vire',
  contextEyebrow: 'Kaj daje odgovorom kontekst',
  contextTitle: 'Poslovanje v ozadju vprašanja.',
  contextBody:
    'Spletni viri pojasnijo javno poslovanje. Zapiski podjetja dodajo vašo terminologijo, prednostne naloge in način dela.',
  contextPrompt:
    'Pomagaj mi razjasniti prednostne naloge podjetja in delovne preference, ki si jih moramo zapomniti.',
  contextAction: 'Gradi naše razumevanje',
  learnEyebrow: 'Prostor za učenje',
  learnTitle: 'Začnite s tem, kar je pomembno zdaj.',
  learnBody:
    'Dodajte izvorno gradivo ali pojasnite, kako deluje vaše podjetje. Poneva lahko predlaga trajne spremembe, ki jih pregledate.',
  learnPrompt:
    'Katere pomembne informacije na podlagi obstoječega znanja našega podjetja manjkajo za delo, ki ga želimo opraviti?',
  learnAction: 'Pogovori se o tem, kaj bi bilo koristno',
  canvasEmptyTitle: 'Že malo konteksta veliko pomeni.',
  canvasEmptyBody:
    'Profil vašega podjetja je izhodišče. Dodajte izvorno gradivo in pregledane zapiske, da bo Poneva bolje razumela vaše delo.',
  pageEyebrow: 'Delovni prostor {company}',
  pageTitle: 'Znanje podjetja',
  pageDescription: 'Viri in razumevanje, na katerih temelji delo aplikacije Poneva.',
  tabOverview: 'Povzetek',
  tabPages: 'Strani',
  tabSources: 'Viri',
  tabReview: 'V pregled',
  proposalApproved: 'Odobren kontekst podjetja',
  proposalDismissed: 'Opuščen predlog',
  proposalRemoval: 'Predlagana odstranitev',
  proposalCorrection: 'Predlagan popravek',
  proposalContext: 'Predlagan kontekst podjetja',
  proposalCurrent: 'Trenutno razumevanje',
  proposalFactGone:
    'Shranjeno dejstvo ni več na voljo. Preden pregledate to odstranitev, osvežite znanje podjetja.',
  proposalReviewFallback: 'Preglejte predlagani kontekst podjetja.',
  proposalNotSaved: 'Še ni shranjeno. Izvirni viri ostanejo nespremenjeni.',
  proposalWaiting: 'Čaka na pregled · urednik odloči v Prejeti pošti',
  proposalSaving: 'Shranjevanje…',
  proposalApproveRemoval: 'Odobri odstranitev',
  proposalApproveClarification: 'Odobri pojasnilo',
  factLabel: 'Dejstvo o podjetju',
  factEyebrow: 'Dejstvo · Vsi v podjetju {company}',
  factSuggestCorrection: 'Predlagaj popravek',
  factAskPrompt: 'Pomagaj mi razumeti ali pojasniti ta shranjeni kontekst podjetja: »{content}«',
  factAsk: 'Vprašaj o tem',
  companyContextHeading: 'Kontekst podjetja',
  companyContextPrompt:
    'Želim pojasniti znanje našega podjetja. Pomagaj mi pregledati, kaj vemo, in predlagati posodobitev.',
  companyContextEmpty:
    'Odobrenih zapiskov še ni. Začnite pogovor o svojem podjetju ali spodaj dodajte izvorno gradivo.',
  refineInChat: 'Izpopolni v klepetu',
  reviewPanelLabel: 'Spremembe znanja za pregled',
  suggestedUpdatesHeading: 'Predlagane posodobitve',
  suggestedUpdatesIntro:
    'Predlogi iz vaših pogovorov. Vi odločite, kaj postane del trajnega znanja vašega podjetja.',
  reviewEmptyTitle: 'Nič ne čaka na vaš pregled.',
  reviewEmptyBody:
    'Ko Poneva predlaga spremembo znanja vašega podjetja, jo boste našli tukaj. Trajne spremembe vedno potrebujejo vašo odobritev.',
  reviewEmptyPrompt:
    'Pomagaj mi pregledati znanje našega podjetja in predlagaj, kaj bi bilo koristno pojasniti naslednje.',
  inclusionPendingApproval: 'Sprememba vključitve v znanje je bila poslana v odobritev.',
  sourcesFileIncluded: 'Datoteka je vključena v iskanje po znanju za svoje trenutno občinstvo.',
  sourcesAddFailed: 'Tega vira ni bilo mogoče dodati.',
  sourcesHeading: 'Gradivo, na katerem temeljijo odgovori.',
  sourcesIntro:
    'Poneva preišče celotno izvorno gradivo, ne le povzetka. Ohranite izvirnike, preverite, kaj je pripravljeno, in izberite, kaj vpliva na vaše odgovore.',
  addSourceHeading: 'Dodajte gradivo svojega podjetja',
  addSourceIntro:
    'Naloženi viri ostanejo zasebni v vaši Knjižnici in vplivajo le na vaše odgovore. Ko jih želite dati na voljo sodelavcem, izberite Deli.',
  uploadSource: 'Naloži vir',
  addSourcePrompt:
    'Pomagaj mi dodati izjavo podjetja kot skupni notranji vir. Vprašaj me, kaj želim zabeležiti; ne izmišljuj si vsebine. Trajne spremembe razumevanja podjetja še vedno potrebujejo mojo odobritev.',
  addThroughChat: 'Dodaj prek klepeta',
  addingSource: 'Dodajanje…',
  addToKnowledge: 'Dodaj v znanje',
  uploadFormats: 'TXT, Markdown, CSV in JSON · Do 5 MB na datoteko',
  sourceExcluded: 'Izključeno iz odgovorov',
  sourcePreparationFailed: 'Priprava ni uspela',
  sourcePreparing: 'Priprava za iskanje',
  sourceWaiting: 'Čaka na pripravo',
  sourceReadinessUnknown: 'Stanje pripravljenosti ni na voljo',
  sourceRetryQueued:
    'Priprava je v čakalni vrsti. Stanje pripravljenosti se bo posodobilo, ko bo končana.',
  sourceIncludedNotice: 'Vir je vključen. Poneva ga bo pripravila za iskanje.',
  sourceExcludedNotice: 'Izključeno iz odgovorov. Izvirni vir je ohranjen.',
  sourceUpdateFailed: 'Tega vira ni bilo mogoče posodobiti.',
  sourceOriginalMaterial: 'Izvirno gradivo vira',
  sourceDiscuss: 'Pogovori se v klepetu',
  sourceDiscussPrompt: 'Pomagaj mi razumeti ali pojasniti »{title}«.',
  sourceExclude: 'Izključi iz odgovorov',
  sourceInclude: 'Vključi v odgovore',
  sourcesLoadFailed: 'Vaših virov nismo mogli naložiti.',
  sourceLibraryLabel: 'Knjižnica virov podjetja',
  sourceListCaption: 'Izvirni viri · vključeni in izključeni',
  sourceSearchLabel: 'Iskanje po virih podjetja',
  sourceSearchPlaceholder: 'Iščite po svojih virih…',
  sourcesFinding: 'Iskanje vaših virov…',
  sourcePagesLabel: 'Strani virov',
  sourceRange: '{from}–{to} od {count}',
  sourceCount: 'one:vir|two:vira|few:viri|other:virov',
  sourcePrevious: 'Prejšnja',
  sourceNext: 'Naslednja',
  sourceNoMatchTitle: 'Ni ujemajočih se virov.',
  sourceNoMatchBody: 'Poskusite z drugo besedno zvezo ali imenom vira.',
  sourceEmptyTitle: 'Dajte svojim vprašanjem trdnejše izhodišče.',
  sourceEmptyBody:
    'Dodajte dokumente podjetja, podatke o izdelkih ali delovne zapiske. Poneva lahko celotno izvorno gradivo uporablja v pogovorih in Skills.',
  indexCheckFailed: 'Priprave virov nismo mogli preveriti.',
  indexRetryQueued:
    'Neuspeli vnosi znanja so v čakalni vrsti za pripravo. Vaše izvorno gradivo je nespremenjeno.',
  indexQueueFailed: 'Priprave nismo mogli dodati v čakalno vrsto. Poskusite znova.',
  indexPreparing: 'Pripravljanje novega znanja za vaše pogovore…',
  indexAttention: 'Nekaj znanja potrebuje pozornost.',
  queuing: 'Dodajanje v čakalno vrsto…',
  retryPreparation: 'Znova poskusi pripravo',
  sourceKindStatement: 'Izjava podjetja',
  sourceKindWebsite: 'Spletno mesto',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:odgovor|two:odgovora|few:odgovori|other:odgovorov',
  factUsedThisWeek: 'Uporabljeno ta teden: {answers}',
  factLastUsed: 'nazadnje uporabljeno: {when}',
  factToday: 'danes',
  factYesterday: 'včeraj',
  factImpact: 'Ta sprememba vpliva na dejstvo, uporabljeno ta teden ({answers}).',
  factCorrectionAbout: 'O tem dejstvu o podjetju: »{content}« ({link})',
  factCorrectionOutdated: 'To ni več aktualno:',
  sourceCanvasRecorded: 'Zabeleženo izvorno gradivo',
  sourceCanvasNotIncluded:
    'Ni vključeno v znanje podjetja. Izvirnik je shranjen za sklicevanje in ga je še vedno mogoče uporabiti v posameznem pogovoru.',
  sourceCanvasOpenOriginal: 'Odpri izvirni vir',
  sourceCanvasUnavailable: 'Vsebina vira ni na voljo.',
  sourceCanvasDiscussPrompt: 'Pomagaj mi razumeti ali pojasniti »{title}«.',
  sourceCanvasDiscuss: 'Pogovori se o tem viru',
  sourceCanvasCorrectionNote:
    'Popravek postane predlagani kontekst podjetja. Zabeleženi vir ostane nespremenjen.',
  contextCanvasEyebrow: 'Razpoložljivi kontekst podjetja',
  contextCanvasTitle: 'Znanje v ozadju tega pogovora.',
  contextCanvasBody:
    'Odobreno razumevanje in izvorno gradivo, ki ga je dodalo vaše podjetje. Na voljo v klepetu in v Skills.',
  contextCanvasOpen: 'Odpri Znanje',
};

export default sl;
